const through = require('through')

const normalizeHeaders = require('airship/modules/request2/utils/normalize-headers')

module.exports = addUAAccept

function addUAAccept() {
  return through(function(reqData) {
    // Ensure the properties we need are present.
    reqData.headers = normalizeHeaders(reqData.headers || {})

    // Only add this if the `Accept` header hasn't already been specified.
    // If it's already there, assume the user knows what they're doing.
    if (!reqData.headers.accept) {
      reqData.headers.accept = 'application/vnd.urbanairship+json; version=3'
    }

    this.queue(reqData)
  })
}
